module.exports = __webpack_public_path__ + "img/ilkhani.e06f926c.jpg";